export default __webpack_public_path__ + "static/Doubt_Clarification-5b93bc886f7e66670143ab77a5a6e394.svg";